const SITE_KEY = import.meta.env.VITE_RECAPTCHA_CLIENT_KEY || '';
const NODE_ENV = import.meta.env.NODE_ENV || 'development';

type Grecaptcha = {
  ready: (callback: () => void) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
};

interface WindowWithOptionalGrecaptcha extends Window {
  grecaptcha?: Grecaptcha;
}
interface WindowWithGrecaptcha extends Window {
  grecaptcha: Grecaptcha;
}

const RECAPTCHA_LOAD_TIMEOUT_MS = 10_000;
const RECAPTCHA_POLL_INTERVAL_MS = 200;

const waitForGrecaptcha = (): Promise<WindowWithGrecaptcha> =>
  new Promise((resolve, reject) => {
    const win = window as unknown as WindowWithOptionalGrecaptcha;
    if (win?.grecaptcha) {
      resolve(win as WindowWithGrecaptcha);
      return;
    }

    const start = Date.now();
    const interval = setInterval(() => {
      if (win?.grecaptcha) {
        clearInterval(interval);
        resolve(win as WindowWithGrecaptcha);
      } else if (Date.now() - start > RECAPTCHA_LOAD_TIMEOUT_MS) {
        clearInterval(interval);
        reject(new Error('reCAPTCHA failed to load within timeout'));
      }
    }, RECAPTCHA_POLL_INTERVAL_MS);
  });

const getReCaptchaToken = async (): Promise<string> => {
  if (NODE_ENV === 'test') {
    return 'test';
  }

  const windowWithRecaptcha = await waitForGrecaptcha();

  return new Promise((resolve, reject) => {
    windowWithRecaptcha.grecaptcha.ready(() => {
      windowWithRecaptcha.grecaptcha
        .execute(SITE_KEY, { action: 'submit' })
        .then((token) => {
          resolve(token);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
};

export default getReCaptchaToken;
